import { render, staticRenderFns } from "./Portfolio.vue?vue&type=template&id=1b1bb1c3&scoped=true&"
import script from "./Portfolio.vue?vue&type=script&lang=js&"
export * from "./Portfolio.vue?vue&type=script&lang=js&"
import style0 from "./Portfolio.vue?vue&type=style&index=0&id=1b1bb1c3&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1b1bb1c3",
  null
  
)

export default component.exports